"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportAction = exports.PayloadStatus = exports.SyncType = exports.SyncStatus = void 0;
var SyncStatus;
(function (SyncStatus) {
    SyncStatus["Done"] = "DONE";
    SyncStatus["Conflict"] = "CONFLICT";
    SyncStatus["Pending"] = "PENDING";
    SyncStatus["DataExportRequested"] = "DATA_EXPORT_REQUESTED";
    SyncStatus["ExportingData"] = "EXPORTING_DATA";
    SyncStatus["DataExported"] = "DATA_EXPORTED";
    SyncStatus["DataExportFailed"] = "DATA_EXPORT_FAILED";
    SyncStatus["PendingReview"] = "PENDING_REVIEW";
    SyncStatus["Reviewed"] = "REVIEWED";
    SyncStatus["SaveDataRequested"] = "SAVE_DATA_REQUESTED";
    SyncStatus["SavingData"] = "SAVING_DATA";
    SyncStatus["DataSavingFailed"] = "DATA_SAVING_FAILED";
    SyncStatus["Failed"] = "FAILED";
    SyncStatus["Synced"] = "SYNCED";
    SyncStatus["Expired"] = "EXPIRED";
    SyncStatus["Canceled"] = "CANCELED";
})(SyncStatus || (exports.SyncStatus = SyncStatus = {}));
var SyncType;
(function (SyncType) {
    SyncType["CloneStorefrontItems"] = "CLONE_STOREFRONT_ITEMS";
    SyncType["ImportStorefrontItems"] = "IMPORT_STOREFRONT_ITEMS";
    SyncType["Items"] = "ITEMS";
    SyncType["Orders"] = "ORDERS";
})(SyncType || (exports.SyncType = SyncType = {}));
var PayloadStatus;
(function (PayloadStatus) {
    PayloadStatus["ReadyToSave"] = "READY_TO_SAVE";
    PayloadStatus["Conflict"] = "CONFLICT";
    PayloadStatus["Saved"] = "SAVED";
})(PayloadStatus || (exports.PayloadStatus = PayloadStatus = {}));
var ImportAction;
(function (ImportAction) {
    ImportAction["Unify"] = "UNIFY";
    ImportAction["Duplicate"] = "DUPLICATE";
    ImportAction["Ignore"] = "IGNORE";
})(ImportAction || (exports.ImportAction = ImportAction = {}));
//# sourceMappingURL=sync.js.map